export enum BrandingImageTypes {
  LOGO = 'logo',
  LOGO_MOBILE = 'logoMobile',
  FAV_ICON = 'favIcon'
}